import iShopBag from "./dashboard/shopping-bag.svg";
import iShop from "./dashboard/shop.svg";
import iPackage from "./dashboard/package.svg";
import iUsers from "./dashboard/users.svg";
import iMotorcycle from "./dashboard/motorcycle.svg";
import iLogoWhite from "./logo/LogoWhite.svg";
import iLogoColor from "./logo/LogoColor.svg";

export const ShopBagSVG = iShopBag;
export const ShopSVG = iShop;
export const PackageSVG = iPackage;
export const UsersSVG = iUsers;
export const MotorcycleSVG = iMotorcycle;

// Logo
export const LogoWhiteSVG = iLogoWhite;
export const LogoColorSVG = iLogoColor;
